/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import ReactTooltip from 'react-tooltip';

type PropsType = {
  discounts: [],
  setDiscounts: () => void,
  toggledClearRows: boolean,
  handleSelectRow: () => void,
  handleDiscountDisabled: (group_id: number, status: boolean) => void,
  eventId: number | string,
  isReadOnly: boolean
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  rows: {
    style: {
      flexShrink: '0'
    }
  },
  cells: {
    style: {
      minWidth: '50px !important'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailDiscountCodesBody = (
  {
    discounts,
    setDiscounts,
    toggledClearRows,
    handleSelectRow,
    eventId,
    handleDiscountDisabled,
    isReadOnly
  }: PropsType): React.Element<'div'> => {
  try {
    mock = require('./tableHeaders/index.js');
  } catch (e) {
    console.warn('File "./tableHeaders/index.js" doesn\'t exist');
  }
  const columns = mock.columns(eventId, handleDiscountDisabled);

  if (isReadOnly) {
    columns.shift();
  }

  const customSort = (selector, direction) => {
    const rows = _.cloneDeep(discounts);


    if (selector === 'applies') {
      const appToAll = [];
      const data = rows.filter(row => {
        if (!row.applied_to_tickets[0]) {
          appToAll.push(row);

          return;
        }

        return true;
      });

      const caseInsensitiveSort = (rowA, rowB) => {
        const a = rowA.applied_to_tickets[0];
        const b = rowB.applied_to_tickets[0];

        if (a > b) {
          return direction === 'asc' ? 1 : -1;
        }

        if (b > a) {
          return direction === 'asc' ? -1 : 1;
        }

        return 0;
      };

      const result = data.sort(caseInsensitiveSort);

      if (direction === 'asc') {
        result.unshift(...appToAll);
      } else result.push(...appToAll);

      setDiscounts(result);
    }

    if (selector === 'perchase') {
      const caseInsensitiveSort = (rowA, rowB) => {
        const a = rowA.usage_per_checkout;
        const b = rowB.usage_per_checkout;

        if (a > b) {
          return direction === 'asc' ? 1 : -1;
        }

        if (b > a) {
          return direction === 'asc' ? -1 : 1;
        }

        return 0;
      };

      const result = rows.sort(caseInsensitiveSort);

      setDiscounts(result);
    }
  };

  return (
    <div className="panel-body">
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <ReactTooltip
            place="right"
            type="light"
            effect="solid"
            multiline
            border
            borderColor='#ddd'
            backgroundColor='white'
            className='ReactTooltipCustom'
          />
          <DataTable
            columns={columns}
            data={discounts}
            customStyles={customStyles}
            selectableRows={!isReadOnly} // add for checkbox selection
            Clicked
            onSelectedRowsChange={(selected: any) => {
              handleSelectRow(selected);
            }}
            clearSelectedRows={toggledClearRows}
            selectableRowsHighlight
            pagination={_.size(discounts) > 10}
            highlightOnHover
            responsive
            striped
            fixedHeader
            noHeader
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
            onSort={(column, sortDirection): void => customSort(column.selector, sortDirection)}
          />
        </div>
      </div>
    </div>
  );
};

export default EventPageDetailDiscountCodesBody;
